export default [
  // web端分享文件预览
  {
    path: "/pdfView",
    component: () =>
      import ("@/CommonDP/components/webShareFileView/pdfView/pdf.vue")
  },
  {
    path: "/imageView",
    component: () =>
      import ("@/CommonDP/components/webShareFileView/imageView/image.vue")
  },
  {
    path: "/txtView",
    component: () =>
      import ("@/CommonDP/components/webShareFileView/txtView/txt.vue")
  },
  {
    path: "/mp4View",
    component: () =>
      import ("@/CommonDP/components/webShareFileView/mp4View/mp4.vue")
  },
  {
    path: "/mainMg/share",
    name: "share",
    component: () =>
      import ("@/CommonDP/components/share/share.vue"),
    meta: { hidden: true },
    children: [{
      path: "/mainMg/share/appShare",
      name: "appShare",
      component: () =>
        import ("@/CommonDP/components/share/appShare/appShare.vue"),
      meta: {
        hidden: true
      },
      // 移动端分享文件预览
      children: [
      // {
      // path: "/appShare/contentList",
      // name: "contentList",
      // component: () =>
      //   import ("@/CommonDP/components/share/appShare/contentList/contentList")
      // },
      // {
      //   path: "/appShare/verify",
      //   name: "verify",
      //   component: () =>
      //     import ("@/CommonDP/components/share/appShare/verify/verify.vue")
      // },
        {
          path: "/appShare/pdfView",
          component: () =>
            import ("@/CommonDP/components/appShareFileView/pdfView/pdf.vue")
        },
        {
          path: "/appShare/imageView",
          component: () =>
            import ("@/CommonDP/components/appShareFileView/imageView/image.vue")
        },
        {
          path: "/appShare/txtView",
          component: () =>
            import ("@/CommonDP/components/appShareFileView/txtView/txt.vue")
        },
        {
          path: "/appShare/mp4View",
          component: () =>
            import ("@/CommonDP/components/appShareFileView/mp4View/mp4.vue")
        }
      ]
    },
    {
      path: "/mainMg/share/webShare",
      name: "webShare",
      component: () =>
        import ("@/CommonDP/components/share/webShare/webShare.vue"),
      meta: {
        hidden: true
      }
    }
    ]
  }
];
